
import { Component, Mixins } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import DishList from '@/components/menu-engineering/DishList.vue';
import { Dish, DishCourseEnum } from '@/api/model';
import { ScoredDish } from '@/logic/menu-engineering/ScoredDish';
import Calculator from '@/logic/menu-engineering/Calculator';
import MenuEngineeringLogic from '@/logic/menu-engineering/MenuEngineeringLogic';
import Score from '@/logic/menu-engineering/Score';
import ContentBlocks from '@/components/content/ContentBlocks.vue';
import MessageToastMixin from '@/mixins/MessageToastMixin';
import CmsContentMixin from '@/mixins/CmsContentMixin';

@Component({
  components: { ContentBlocks, LayoutDefault, DishList },
})
export default class MenuEngineeringCategory extends Mixins(
  MessageToastMixin,
  CmsContentMixin,
) {
  get category(): string {
    return this.$route.params.category;
  }

  get score(): Score {
    const index = this.category.slice(0, -1).toUpperCase();
    const mapped = index !== 'LAGGARD' ? index : 'LOSER';
    return Score[mapped as keyof typeof Score];
  }

  get state() {
    return this.$store.state.menuEngineering;
  }

  get course(): DishCourseEnum {
    return this.state.activeCourse;
  }

  get restaurantId(): string {
    return this.state.activeRestaurantId;
  }

  get dishes(): ScoredDish[] {
    const allDishes = Calculator.calculate(this.state.dishes);
    const filteredDishes = MenuEngineeringLogic.filterDishes(
      allDishes,
      this.restaurantId,
      this.course,
    );
    return filteredDishes.filter(
      (dish: ScoredDish) => dish.score === this.score,
    );
  }

  created() {
    this.getDishes();
  }

  getDishes() {
    this.$store.dispatch('menuEngineering/getDishes');
  }

  mounted() {
    this.fetchContent();
  }

  async deleteDish(deleteDish: Dish) {
    try {
      await this.$store.dispatch('menuEngineering/deleteDish', deleteDish);
    } catch (e) {
      this.showError(this.$t('menuEngineering.label.dishNotDeleted'));
    }
  }
}
